import { call, put, takeLatest } from 'redux-saga/effects';
import {
  getCalculationItems as getCalculationItemsApi,
  createCalculationItem as createCalculationItemApi,
  updateCalculationItem as updateCalculationItemApi,
  deleteCalculationItem as deleteCalculationItemApi,
  getCalculation as getCalculationApi
} from '../../../services/calculation/calculation-service';
import {
  fetchCalculationItemsSuccess,
  fetchCalculationItemsFailure,
  createCalculationItemSuccess,
  createCalculationItemFailure,
  updateCalculationItemSuccess,
  updateCalculationItemFailure,
  deleteCalculationItemSuccess,
  deleteCalculationItemFailure,
  fetchCalculationSuccess
} from '../actions';

// Worker Saga: Handles FETCH_CALCULATION_ITEMS_REQUEST action
function* fetchCalculationItemsSaga(action) {
  try {
    const { payload: { calculationId } } = action;
    const items = yield call(getCalculationItemsApi, calculationId);
    
    // Include calculationId in the success action
    yield put({
      ...fetchCalculationItemsSuccess(items),
      meta: { calculationId }
    });
  } catch (error) {
    yield put(fetchCalculationItemsFailure(error.message));
  }
}

// Worker Saga: Handles CREATE_CALCULATION_ITEM_REQUEST action
function* createCalculationItemSaga(action) {
  try {
    const { payload: { calculationId, itemData } } = action;
    const newItem = yield call(createCalculationItemApi, calculationId, itemData);
    
    // Ensure the calculationId is included in the item
    const itemWithCalculationId = {
      ...newItem,
      calculationId
    };
    
    yield put(createCalculationItemSuccess(itemWithCalculationId));
    
    // Refresh the entire calculation to get updated data
    const refreshedCalculation = yield call(getCalculationApi, calculationId);
    yield put(fetchCalculationSuccess(refreshedCalculation));
  } catch (error) {
    yield put(createCalculationItemFailure(error.message));
  }
}

// Worker Saga: Handles UPDATE_CALCULATION_ITEM_REQUEST action
function* updateCalculationItemSaga(action) {
  try {
    const { payload: { itemId, itemData, calculationId } } = action;
    const updatedItem = yield call(updateCalculationItemApi, itemId, itemData);
    
    // Include calculationId in the success action
    yield put({
      ...updateCalculationItemSuccess(updatedItem),
      meta: { calculationId: calculationId || updatedItem.calculationId }
    });
    
    // Refresh the entire calculation to get updated data
    const calcId = calculationId || updatedItem.calculationId;
    if (calcId) {
      const refreshedCalculation = yield call(getCalculationApi, calcId);
      yield put(fetchCalculationSuccess(refreshedCalculation));
    }
  } catch (error) {
    yield put(updateCalculationItemFailure(error.message));
  }
}

// Worker Saga: Handles DELETE_CALCULATION_ITEM_REQUEST action
function* deleteCalculationItemSaga(action) {
  try {
    const { payload: { itemId, calculationId } } = action;
    
    yield call(deleteCalculationItemApi, itemId);
    
    yield put(deleteCalculationItemSuccess({itemId}));
    
    // Refresh the entire calculation to get updated data
    if (calculationId) {
      const refreshedCalculation = yield call(getCalculationApi, calculationId);
      yield put(fetchCalculationSuccess(refreshedCalculation));
    }
  } catch (error) {
    yield put(deleteCalculationItemFailure(error.message));
  }
}

// Watcher Saga: Watches for calculation item related actions
function* watchCalculationItems() {
  yield takeLatest('calculations/FETCH_CALCULATION_ITEMS_REQUEST', fetchCalculationItemsSaga);
  yield takeLatest('calculations/CREATE_CALCULATION_ITEM_REQUEST', createCalculationItemSaga);
  yield takeLatest('calculations/UPDATE_CALCULATION_ITEM_REQUEST', updateCalculationItemSaga);
  yield takeLatest('calculations/DELETE_CALCULATION_ITEM_REQUEST', deleteCalculationItemSaga);
}

export default watchCalculationItems;
